var map = {
	"./browser/apple-pay.svg": "h/Pj",
	"./browser/google-pay.svg": "IoSQ",
	"./card/american express.svg": "R5Pn",
	"./card/diners club.svg": "RSXj",
	"./card/jcb.svg": "Q8V6",
	"./card/mastercard.svg": "5wyd",
	"./card/visa.svg": "Fzbm",
	"./konbini/family-mart.svg": "y8Jk",
	"./konbini/lawson.svg": "/w8B",
	"./konbini/seven-eleven.svg": "fZT1"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "Kfew";